import { IAsset, IAssetResponse, IAssetVersion, IFile } from "@desp-aas/desp-ui-fwk"
import { IAssetFilter } from "../../utils/catalog"

export type IAssetTabProps = {
    asset: IAsset
    assetMetadata?: IAssetFilter[]
    loadingAssetMetadata: boolean
    editMode: boolean
    updateAsset: (updates: Partial<IAsset>) => any
    updating: boolean
    selectedVersion: IAssetVersion|undefined
    assetVersions: IAssetVersion[]|undefined
    assetResponse: IAssetResponse|undefined
}

export const defaultNullPlaceholder = "Not available";

export const checkFieldHasUpdates = (asset: IAsset, updates: Partial<IAsset>, field: keyof IAsset) => {
    return updates[field] !== asset[field];
}
export const checkMetadataFieldHasUpdates = (asset: IAsset, updates: Partial<IAsset>, field: string) => {
    return updates.metadata?.[field] !== asset.metadata?.[field];
}


export const checkFileIsNew = (file: IFile, latestVersionDate: string) => {
    return new Date(file.commitDate.split('.')[0]) > new Date(latestVersionDate.split('.')[0]);
}
